module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    attrs: {
      "span": 10
    }
  }, [_c('img', {
    staticClass: "Img",
    attrs: {
      "src": require("../../static/img/logo3.png")
    }
  })]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "position": "relative",
      "height": "60px"
    },
    attrs: {
      "span": 5
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('p', [_vm._v("当前用户："), _c('span', [_vm._v(_vm._s(_vm.userName))]), _c('span', {
    staticClass: "userinfo-inner",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("安全退出")])])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded',
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [
    [(_vm.Limits.stat_device_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/DeviceStatusManagement"
      }
    }, [_c('i', {
      staticClass: "el-icon-upload"
    }), _vm._v("设备状态管理\n          ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.stat_summary_index || _vm.Limits.stat_new_online_index || _vm.Limits.stat_active_device_index || _vm.Limits.stat_active_device_stat || _vm.Limits.stat_online_condition_index) ? _c('el-submenu', {
      attrs: {
        "index": "1"
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "el-icon-data-analyze"
    }), _vm._v("物联数据分析")]), _vm._v(" "), (_vm.Limits.stat_summary_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/AnalyzeOverviewManagement"
      }
    }, [_vm._v("概览\n            ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.stat_active_device_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/AnalyzeActiveDeviceManagement"
      }
    }, [_vm._v("\n              活跃设备\n            ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.stat_active_device_stat) ? _c('el-menu-item', {
      attrs: {
        "index": "/AnalyzeActivePeriodManagement"
      }
    }, [_vm._v("\n              活跃周期\n            ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.stat_online_condition_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/AnalyzeOnlineDurationManagement"
      }
    }, [_vm._v("连接时长\n            ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.Limits.candidate_index || _vm.Limits.exhibition1_target_index || _vm.Limits.questionnaire_index || _vm.Limits.unallocatedreservation_index || _vm.Limits.allocatedreservation_index || _vm.Limits.feedback_index) ? _c('el-submenu', {
      attrs: {
        "index": "2"
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "el-icon-service"
    }), _vm._v("客户管理")]), _vm._v(" "), (_vm.Limits.questionnaire_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/CustomerInformation"
      }
    }, [_vm._v("客户信息管理\n            ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.questionnaire_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/CustomerPopular"
      }
    }, [_vm._v("客户推广管理\n            ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.exhibition1_target_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/ActiveUser"
      }
    }, [_vm._v("北京福祉客户签到\n            ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.candidate_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/SeedCandidate"
      }
    }, [_vm._v("种子项目候选人")]) : _vm._e(), _vm._v(" "), (_vm.Limits.unallocatedreservation_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/CustomerReservation"
      }
    }, [_vm._v("\n              未分配预约管理\n            ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.allocatedreservation_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/CustomerReservationed"
      }
    }, [_vm._v("\n              已分配预约管理\n            ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.Limits.sport_summary_index || _vm.Limits.dev_sport_data_index || _vm.Limits.dev_test_data_index || _vm.Limits.dev_sport_log_index || _vm.Limits.dev_sport_flash_log_index || _vm.Limits.device_index || _vm.Limits.dev_data_index || _vm.Limits.dev_log_index || _vm.Limits.dev_flash_log_index) ? _c('el-submenu', {
      attrs: {
        "index": "3"
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "el-icon-data-management"
    }), _vm._v("物联数据管理")]), _vm._v(" "), (_vm.Limits.dev_test_data_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/EquipmentMonitoringtest"
      }
    }, [_vm._v("\n              设备监控日志[测试]\n            ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.device_index || _vm.Limits.dev_data_index || _vm.Limits.dev_log_index || _vm.Limits.dev_flash_log_index) ? _c('el-submenu', {
      attrs: {
        "index": "3-1"
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("标准版设备")]), _vm._v(" "), (_vm.Limits.device_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/EquipmentInformation"
      }
    }, [_vm._v("设备信息\n              ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.dev_data_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/EquipmentMonitoring"
      }
    }, [_vm._v("设备监控日志\n              ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.dev_log_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/EquipmentCycleLog"
      }
    }, [_vm._v("设备周期日志\n              ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.dev_flash_log_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/EquipmentFlash"
      }
    }, [_vm._v("设备Flash日志\n              ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.Limits.sport_summary_index || _vm.Limits.dev_sport_data_index || _vm.Limits.dev_sport_log_index || _vm.Limits.dev_sport_flash_log_index || _vm.Limits.dev_sport_error_log_index) ? _c('el-submenu', {
      attrs: {
        "index": "3-2"
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("运动版设备")]), _vm._v(" "), (_vm.Limits.sport_summary_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/SportEquipment"
      }
    }, [_vm._v("设备信息\n              ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.dev_sport_data_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/SportMonitoring"
      }
    }, [_vm._v("设备监控日志\n              ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.dev_sport_log_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/SportCycleLog"
      }
    }, [_vm._v("设备周期日志\n              ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.dev_sport_flash_log_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/SportFlash"
      }
    }, [_vm._v("设备Flash日志\n              ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.dev_sport_error_log_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/SportErr"
      }
    }, [_vm._v("设备错误日志\n              ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (true) ? _c('el-submenu', {
      attrs: {
        "index": "3-3"
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("智能轮椅")]), _vm._v(" "), (true) ? _c('el-menu-item', {
      attrs: {
        "index": "/WheelChairMonitoring"
      }
    }, [_vm._v("监控日志[智能轮椅]\n              ")]) : _vm._e(), _vm._v(" "), (true) ? _c('el-menu-item', {
      attrs: {
        "index": "/WheelChairCycleLog"
      }
    }, [_vm._v("周期日志[智能轮椅]\n              ")]) : _vm._e(), _vm._v(" "), (true) ? _c('el-menu-item', {
      attrs: {
        "index": "/WheelChairFlash"
      }
    }, [_vm._v("Flash日志[智能轮椅]\n              ")]) : _vm._e(), _vm._v(" "), (true) ? _c('el-menu-item', {
      attrs: {
        "index": "/WheelChairErr"
      }
    }, [_vm._v("错误日志[智能轮椅]\n              ")]) : _vm._e()], 2) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.Limits.task_index || _vm.Limits.nonwarehoused_index || _vm.Limits.warehoused_index) ? _c('el-submenu', {
      attrs: {
        "index": "4"
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "el-icon-product-process"
    }), _vm._v("生产流程管理")]), _vm._v(" "), (_vm.Limits.task_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/EquipmentBelow"
      }
    }, [_vm._v("设备下单管理")]) : _vm._e(), _vm._v(" "), (_vm.Limits.nonwarehoused_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/StorageEquipment"
      }
    }, [_vm._v("待入库设备管理\n            ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.warehoused_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/WarehousingEquipment"
      }
    }, [_vm._v("已入库设备管理\n            ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('el-submenu', {
      attrs: {
        "index": "5"
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "el-icon-other"
    }), _vm._v("其他")]), _vm._v(" "), (_vm.Limits.member_open_close_game) ? _c('el-menu-item', {
      attrs: {
        "index": "/MobileAppUserManagement"
      }
    }, [_vm._v("App用户管理\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('el-submenu', {
      attrs: {
        "index": "6"
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "el-icon-settings"
    }), _vm._v("设置")]), _vm._v(" "), (_vm.Limits.user_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/AccountManagement"
      }
    }, [_vm._v("后台账户管理\n            ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.role_index) ? _c('el-menu-item', {
      attrs: {
        "index": "/RoleManage"
      }
    }, [_vm._v("角色管理\n            ")]) : _vm._e()], 2)]
  ], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24,
      "id": "lbfbread"
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }))], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76a54986"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 1286
// module chunks = 1